import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import PopOver from '@bibliocommons/base-accessibility-pop-over';
import { Info as InfoIcon } from '@bibliocommons/base-icons';

import BorrowingQuotas from '../../shared/BorrowingQuotas';

const renderTriggerContent = () => (
  <div>
    <InfoIcon />
    &nbsp;
    <FormattedMessage id="checkedout_see_limits" />
  </div>
);

export default function CheckedOutQuotasPopOver({ quotas }) {
  if (!quotas || quotas.size === 0) {
    return null;
  }

  return (
    <span className="cp-checked-out-quotas-pop-over">
      <PopOver
        href="#checked-out-quotas-pop-over"
        triggerContent={renderTriggerContent()}>
        <BorrowingQuotas
          title={<FormattedMessage id="checkedout_my_limits" />}
          quotas={quotas} />
      </PopOver>
    </span>
  );
}


CheckedOutQuotasPopOver.propTypes = {
  quotas: ImmutablePropTypes.list
};



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/CheckedOutQuotasPopOver/CheckedOutQuotasPopOver.jsx